import { UISchemaElement } from '@jsonforms/core';
import { inject } from 'vue';
import merge from 'lodash/merge';
import { defaultStyles } from './defaultStyles';
import { checkTheme } from 'src/utils/config';

const createEmptyStyles = (): Styles => ({
  control: {},
  verticalLayout: {},
  horizontalLayout: {},
  group: {},
  arrayList: {},
  label: {},
  dialog: {},
});

export interface Styles {
  control: {
    root?: string;
    wrapper?: string;
    label?: string;
    description?: string;
    error?: string;
    input?: string;
    textarea?: string;
    select?: string;
    option?: string;
    'date-time'?: string;
    accordion?: string;
  };
  dialog: {
    root?: string;
    title?: string;
    body?: string;
    actions?: string;
    buttonPrimary?: string;
    buttonSecondary?: string;
  };
  verticalLayout: {
    root?: string;
    item?: string;
  };
  horizontalLayout: {
    root?: string;
    item?: string;
  };
  group: {
    root?: string;
    label?: string;
    item?: string;
  };
  arrayList: {
    root?: string;
    legend?: string;
    addButton?: string;
    label?: string;
    itemWrapper?: string;
    noData?: string;
    item?: string;
    itemToolbar?: string;
    itemLabel?: string;
    itemContent?: string;
    itemExpanded?: string;
    itemMoveUp?: string;
    itemMoveDown?: string;
    itemDelete?: string;
  };
  label: {
    root?: string;
  };
}

export const useStyles = (element?: UISchemaElement, options?: { title?: string }) => {
  const userStyles = inject('styles', defaultStyles);
  if (checkTheme('common')) {
    userStyles.control.label = `title2-bold mb-6 ${options?.title || ''}`;
    userStyles.control.accordion = `!mb-6 -mt-6 md:!mb-10 md:-mt-10`;
  }
  if (checkTheme('volvo', 'tesla', 'aa', 'suzuki', 'cinch', 'crashdaddy', 'landrover')) {
    userStyles.control.label = 'title2-bold mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('jaguar')) {
    userStyles.control.label = 'title2 mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('jlr', 'referral')) {
    userStyles.control.label = 'title2-bold mb-6 !font-widget-secondary';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('bmw', 'toyota')) {
    userStyles.control.label = 'title3 mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('mopar')) {
    userStyles.control.label = 'title3 mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('jeep')) {
    userStyles.control.label = 'title3 mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('mini')) {
    userStyles.control.label = '!font-widget-primary title3-bold mb-6';
    userStyles.control.accordion = '!mb-6 -mt-6 md:!mb-10 md:-mt-10';
  }
  if (checkTheme('volkswagen', 'bentley', 'vwg')) {
    userStyles.control.label = 'title3 mb-6';
    userStyles.control.accordion = 'md:!mb-10 md:-mt-10';
  }
  if (checkTheme('audi')) {
    userStyles.control.label = 'title3-bold mb-6';
    userStyles.control.accordion = 'md:!mb-10 md:-mt-10';
  }
  if (checkTheme('samsung')) {
    userStyles.control.label = 'title3-bold mb-6';
    userStyles.control.accordion = 'md:!mb-10 md:-mt-10';
  }
  if (!element?.options?.styles) {
    return userStyles;
  }
  const styles = createEmptyStyles();
  if (userStyles) {
    merge(styles, userStyles);
  } else {
    merge(styles, defaultStyles);
  }
  if (element?.options?.styles) {
    merge(styles, element.options.styles);
  }
  return styles;
};
